import { Injectable, inject } from "@angular/core";
import { IframeMessagesService } from "../iframe-messages-service/iframe-messages.service";
import { ResponseErrorHandlerService } from "../response-error-handler-service/response-error-handler.service";

@Injectable({
    providedIn: "root",
})
export class IFirmContactsService {
    private readonly iframeMessagesService = inject(IframeMessagesService);
    private readonly responseErrorHandlerService = inject(ResponseErrorHandlerService);

    private accessibleContacts = new Set<number>();
    private acccessibleContactsLoadPromise: Promise<Set<number>>;

    isContactAccessible(contactId: number) {
        return this.accessibleContacts.has(contactId);
    }

    async getAccessibleContacts(forceReload = false): Promise<Set<number> | undefined> {
        if (forceReload) {
            this.accessibleContacts.clear();
        }
        if (forceReload || !this.acccessibleContactsLoadPromise) {
            this.acccessibleContactsLoadPromise = this.loadAccessibleContacts();
        }
        return this.acccessibleContactsLoadPromise;
    }

    private async loadAccessibleContacts(): Promise<Set<number> | undefined> {
        if (!this.accessibleContacts?.size) {
            try {
                const result = await this.iframeMessagesService.postMessageResp("getAccessibleContacts", {}, "gotAccessibleContacts");
                if (result.status === "success") {
                    this.accessibleContacts = new Set(result.response.Data as number[]);
                } else {
                    this.responseErrorHandlerService.showPopup({
                        typeLayout: "ERROR",
                        messageCode: "defaultError",
                    });
                }
            } catch {
                this.responseErrorHandlerService.showPopup({
                    typeLayout: "ERROR",
                    messageCode: "defaultError",
                });
            }
        }
        return this.accessibleContacts;
    }
}
